export interface FluidLineItem {
    label: string
    lowOrNeeded: boolean
    leakDetected: boolean
}

function fluid(label: string): FluidLineItem {
    return { label, lowOrNeeded: false, leakDetected: false }
}

export interface ConditionCheckItem {
    label: string
    checked: boolean
}

function condition(label: string): ConditionCheckItem {
    return { label, checked: false }
}

export class GreaseFluidRequest {
    id?: string
    dateTime: Date | null = new Date()
    job = ''
    operatorName: number = 0
    equipmentNumber = ''
    hoursMileage = ''

    fluids: FluidLineItem[] = [
        fluid('Engine Oil'),
        fluid('Hydraulic Oil'),
        fluid('Coolant'),
        fluid('Gear Oil'),
    ]

    greaseRoutineLubrication = false
    greaseDryOrNoisy = false

    otherFluid = ''

    conditionChecks: ConditionCheckItem[] = [
        condition('No visible leaks (engine, hydraulic lines, radiator, seals)'),
        condition('Equipment needs serviced'),
        condition('Equipment operates normally (no overheating, abnormal noise, or warning lights)'),
    ]

    additionalNotes = ''
}
